<template>
  <el-tabs ref="tabs"
           :class="['menu-tabs', {'menu-tabs-titled': !!title}]"
           tab-position="left"
           v-bind="$attrs"
           v-on="$listeners">
    <slot></slot>
  </el-tabs>
</template>

<script>
export default {
  name: 'MenuTabs',
  props: {
    title: String
  },
  methods: {
    initTabTitle () {
      if (this.title) {
        this.$el.querySelector('.el-tabs__header')
          .setAttribute('menu-title', this.title)
      }
    }
  },
  mounted () {
    this.initTabTitle()
  }
}
</script>

<style lang="scss">
  .menu-tabs {
    height: 100%;
    &.menu-tabs-titled {
      & > .el-tabs__header {
        position: relative;
        padding-top: 40px;
        box-sizing: border-box;
        &:before {
          content: attr(menu-title);
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          height: 40px;
          color: #909399;
          font-size: 12px;
          text-align: center;
          line-height: 40px;
        }
      }
    }
    & > .el-tabs__header {
      margin-right: 8px!important;
      min-width: 112px;
      background-color: #fff;
      .el-tabs__nav-wrap {
        margin-right: 0!important;
        &:after {
          display: none;
        }
        .el-tabs__nav-scroll {
          .el-tabs__nav {
            .el-tabs__active-bar {
              left: 0;
              width: auto;
              opacity: .1;
            }
            .el-tabs__item {
              font-size: 12px;
              text-align: left;
            }
          }
        }
      }
    }
    & > .el-tabs__content {
      height: 100%;
      .el-tab-pane {
        height: 100%;
      }
    }
  }
</style>
